<template>
<div>
    <lcontainer class="mb-4">
        <div class="heading flex flex-row items-center justify-between py-4 px-8">
            <div class="page text-white">Settings</div>
            <div></div>
        </div>
    </lcontainer>
    <div>
        <lcontainer>
            <div class="py-4 px-8 flex flex-wrap">
                <div class="w-full md:w-1/2 items-center form-row my-4 px-4">
                    <div class="flex flex-wrap justify-between">
                        <page-header class="py-2 tenant-main-color">User Information</page-header>
                    </div>
                    <div class="">
                        <div class="flex flex-row items-center form-row mb-8">
                            <div class="modal-field font-semibold">First Name:</div>
                            <div class="flex-grow ml-auto">
                                <linput type="text" name="fname" v-model="form.first_name" :errorMessage="errors.first_name" :error="errors.first_name" placeholder="First Name" />
                            </div>
                        </div>
                        <div class="flex flex-row items-center form-row mb-8">
                            <div class="modal-field font-semibold ">Last Name:</div>
                            <div class="flex-grow ml-auto">
                                <linput type="text" v-model="form.last_name" :errorMessage="errors.last_name" :error="errors.last_name" placeholder="Last Name" />
                            </div>
                        </div>
                        <div class="flex flex-row items-center form-row mb-8">
                            <div class="modal-field font-semibold ">Email:</div>
                            <div class="flex-grow ml-auto">
                                <linput type="email" :disable="true" v-model="form.email" :errorMessage="errors.email" :error="errors.email" placeholder="Email" />
                            </div>
                        </div>

                        <div class="flex flex-row items-center form-row mb-8">
                            <div class="modal-field font-semibold">Gender:</div>
                            <div class="flex-grow ml-auto relative inline-block w-full text-gray-700">
                              <select v-model="form.gender" class="w-full h-10 pl-3 pr-6 text-base placeholder-gray-600 border rounded-lg appearance-none focus:shadow-outline">
                                <option :value="form.gender" selected disabled>{{ form.gender }}</option>
                                <option value="male" >Male</option>
                                <option value="female">Female</option>
                              </select>
                              <div class="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                                <svg class="w-4 h-4 fill-current" viewBox="0 0 20 20"><path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" fill-rule="evenodd"></path></svg>
                              </div>
<!--                                <lselect :error="errors.gender" v-model="form.gender" :items="gender" :editValue="form.gender" placeholder="Select Gender" />-->
                            </div>
                        </div>
                        <div class="flex flex-row items-center form-row mb-8">
                            <div class="modal-field font-semibold ">Phone Number:</div>
                            <div class="flex-grow ml-auto">
                                <linput type="text" name="phone"  :error="errors.phone_number" :errorMessage="errors.phone_number" v-model="form.phone_number" placeholder="Phone Number" />
                            </div>
                        </div>


                        <div class="flex  flex-column items-center form-row mb-8">
                            <div class="modal-field font-semibold ">Select Phone Network:</div>
                            <div class="flex-grow  flex-col">
                                <span class="m-3">
                                <label>MTN</label>
                                <input name="mtn" type="radio"   :checked="'MTN' == form.phone_number_network" value="MTN" :error="errors.phone_number_network" :errorMessage="errors.phone_number_network" v-model="form.phone_number_network" placeholder="Phone Number" />
                                </span>
                                <span class="m-3">
                                <label>Airtel</label>
                                <input  :checked="'AIRTEL' == form.phone_number_network" name="AIRTEL" value="AIRTEL" type="radio"  :error="errors.phone_number_network" :errorMessage="errors.phone_number_network" v-model="form.phone_number_network" placeholder="Phone Number" />
                                </span>
                                <span class="m-3">
                                <label>9Mobile</label>
                                <input name="9mobile"  :checked="'9MOBILE' == form.phone_number_network" value="9MOBILE" type="radio"  :error="errors.phone_number_network" :errorMessage="errors.phone_number_network" v-model="form.phone_number_network" placeholder="Phone Number" />
                                </span>
                                <span class="m-3">
                                <label>GLO</label>
                                <input name="Glo"  :checked="'GLO' == form.phone_number_network" value="GLO" type="radio"  :error="errors.phone_number_network" :errorMessage="errors.phone_number_network" v-model="form.phone_number_network" placeholder="Phone Number" />
                                </span>
                            </div>
                        </div>

                        <!--<div v-if="getSettings.data_bypass" class="flex flex-row items-center form-row mb-8">

                            <div class="modal-field font-semibold ">Active Sim for data free browsing</div>
                            <div class="my-2">

                                <switches class="ml-5" color="green" v-model="form.phone_number_data_verified">
                                </switches>
                                <span class="ml-4 mb-2 pb-2 font-bold">{{
                    form.phone_number_data_verified ? "Yes" : "No"
                  }}</span>
                            </div>

                        </div>-->
                        <div class="flex flex-row items-center form-row mb-8">
                            <div class="modal-field font-semibold ">Bio (optional):</div>
                            <div class="flex-grow ml-auto">
                                <ltextarea v-model="form.bio" :errorMessage="errors.bio" :error="errors.bio" placeholder="User Bio" />
                            </div>
                        </div>
                        <div class="flex flex-row items-center form-row mb-8">
                            <div class="modal-field font-semibold ">Goals (optional):</div>
                            <div class="flex-grow ml-auto">
                                <ltextarea v-model="form.goals" :errorMessage="errors.goals" :error="errors.goals" placeholder="User Goals" />
                            </div>
                        </div>
                        <div class="flex flex-row items-center form-row mb-8">
                            <div class="modal-field font-semibold ">Interests (optional):</div>
                            <div class="flex-grow ml-auto">
                                <ltextarea v-model="form.interests" :errorMessage="errors.interests" :error="errors.interests" placeholder="User Interests" />
                            </div>
                        </div>
                    </div>

                    <lms-button @click="handleFormSubmit" class="m-2 inline" textColor="#fff">Update Bio</lms-button>
                </div>
                <div class="w-full md:w-1/2 items-center form-row my-4 px-4">
                    <div>
                        <div class="flex flex-wrap justify-between">
                            <page-header class="py-2 tenant-main-color">Progress</page-header>
                        </div>

                        <div class="flex items-center tenant-main-color mx-8">
                            <div class="text-5xl font-bold">
                                {{ user.courses_completed }}
                            </div>
                            <div>
                                <p>courses completed</p>
                            </div>
                        </div>
                        <lms-button class="mx-2 inline" textColor="#fff">Go to Certificates</lms-button>

                        <div class="flex items-center tenant-main-color mx-8">
                            <div class="text-5xl font-bold">
                                {{ user.courses_in_progress }}
                            </div>
                            <div>
                                <p>courses in progress</p>
                            </div>
                        </div>
                        <lms-button @click="$router.push({ name: 'learner-enrolled-courses' })" class="mx-2 inline" textColor="#fff">Go to courses</lms-button>

                        <div class="flex items-center tenant-main-color mx-8">
                            <div class="text-5xl font-bold">
                                {{ user.reward_point }}
                            </div>
                            <div>
                                <p>points earned</p>
                            </div>
                        </div>
                        <lms-button @click="$router.push({ name: 'learner-leaderboard-home' })" class="mx-2 inline" textColor="#fff">Go to Leaderboard</lms-button>
                    </div>
                    <div>
                        <div class="flex flex-wrap justify-between">
                            <page-header class="py-2 tenant-main-color">Security</page-header>
                        </div>
                        <div class="flex flex-row justify-between my-4">
                            <div class="tenant-main-color font-semibold">Password:</div>
                            <div>
                                <p>***********</p>
                            </div>
                        </div>
                    </div>
                    <lms-button @click="$Bus.$emit('update-password')" class="m-2 inline" textColor="#fff">Update Password</lms-button>
                </div>
            </div>

            <hr />
            <div class="py-4 px-8 flex flex-wrap">
                <div class="w-full md:w-1/2 items-center form-row my-4 px-4">
                    <page-header class="py-2 tenant-main-color">Badges</page-header>
                    <ul class=" md:px-12 flex flex-wrap">
                        <li v-for="badge in user.badges" :key="badge.id">
                            {{ badge.title }}
                        </li>
                    </ul>
                </div>
            </div>
        </lcontainer>
    </div>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters,
    mapMutations
} from "vuex";
import Switches from "vue-switches";
export default {
    components: {
        LmsButton: () => import("@/components/general/button"),
        lcontainer: () => import("@/components/general/container"),
        LmsTable: () => import("@/components/admin/admin-table"),
        PageHeader: () => import("@/components/general/pageheader"),
        LmsSelect: () => import("@/components/forms/select"),
        linput: () => import("@/components/general/input"),
        lselect: () => import("@/components/forms/select"),
        ltextarea: () => import("@/components/general/textarea"),
        LmsOutlineButton: () => import("@/components/general/outline_button"),
        Switches
    },
    computed: {
        ...mapGetters(["getUser", "getSettings"]),
    },
    data() {
        return {
            form: {
                first_name: "",
                last_name: "",
                email: "",
                phone: "",
                gender: "",
                role: "",
                phone_number_network:""
            },
            errors: [],
            error: {},
            user: {},
            search: "",
            sort: [{
                    text: "Name",
                    value: "Name"
                },
                {
                    text: "Email",
                    value: "Email"
                },
            ],
            gender: [{
                    text: "Male",
                    value: "male",
                },
                {
                    text: "Female",
                    value: "female",
                },
            ],
            filter: [{
                    text: "Tenants assigned to me",
                    value: "Tenants assigned to me"
                },
                {
                    text: "All Tenants",
                    value: "All Tenants"
                },
            ],
        };
    },
    methods: {
        ...mapActions(["fetchAdminRoles", "updateProfile", "fetchProfile"]),
        ...mapMutations(["updateLoader"]),
        async handleFormSubmit() {
            this.errors = [];
            if (this.$route.query.initial === "true") {
                this.form.phone_number_data_verified = true;

            }
            if(this.form.phone_number_network === ""){
                   this.$Bus.$emit("notify", {
                        type: "error",
                        message: 'Please Select a network'
                    });
                    return;
            }
            
            let res = await this.updateProfile(this.form);

            if (res.status == 200) {
                this.$emit("notify", {
                    type: "success",
                    message: "Profile successfully Updated",
                });
                setTimeout(() => {
                    this.$router.push({
                        name: 'learner-enrolled-courses'
                    })
                }, 3000)

            } else {
                if (res.status == 400) {
                    this.$Bus.$emit("notify", {
                        type: "error",
                        message: res.data.errors ?
                            res.data.errors[0].title : "An error occured",
                    });
                }
            }
        },
    },
    async mounted() {
        this.updateLoader(true)
        let res = await this.fetchProfile();
        this.user = res.data.data.user;
        //console.log({ res: this.user });
        let {
            email,
            first_name,
            gender,
            last_name,
            phone_number,
            phone_number_data_verified,
            phone_number_network,
        } = this.user;
        // this.fetchAdminRoles();
        this.form = {
            email,
            first_name,
            gender,
            last_name,
            phone_number,
            phone_number_data_verified,
            phone_number_network

        };
        //this.form.goals = this.user.learner_profile.goals ?? ''
        //this.form.bio = this.user.learner_profile.bio ?? ''
        //this.form.interests = this.user.learner_profile.interests ?? ''

        this.updateLoader(false)
        //console.log({ ggg: this.form });
    },
};
</script>

<style scoped>
li {
    list-style: circle;
}
</style>
